import React from 'react';

const CardSkeleton = ({ type = 'chart' }) => {
  if (type === 'scalar') {
    return (
      <div className="flex flex-col items-center justify-center h-full animate-pulse">
        <div className="h-10 w-40 bg-gray-200 rounded-lg mb-3"></div>
        <div className="h-6 w-28 bg-gray-100 rounded-lg"></div>
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="flex flex-col h-full p-4 animate-pulse">
        {/* Header */}
        <div className="flex gap-4 mb-4 pb-3 border-b border-gray-100">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-4 bg-gray-200 rounded flex-1"></div>
          ))}
        </div>
        {/* Rows */}
        {[1, 2, 3, 4, 5].map((row) => (
          <div key={row} className="flex gap-4 py-3">
            {[1, 2, 3, 4].map((col) => (
              <div key={col} className="h-3 bg-gray-100 rounded flex-1"></div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  // Chart skeleton
  return (
    <div className="flex flex-col h-full p-4 animate-pulse">
      {/* Legend placeholder */}
      <div className="flex gap-4 mb-4 justify-center">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="h-3 w-3 bg-gray-200 rounded-full"></div>
            <div className="h-3 w-16 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
      {/* Chart area */}
      <div className="flex-1 flex items-end justify-around gap-2 pb-4">
        {[60, 80, 45, 90, 70, 55, 85].map((height, i) => (
          <div
            key={i}
            className="bg-gray-200 rounded-t-lg flex-1 max-w-[40px]"
            style={{ height: `${height}%` }}
          ></div>
        ))}
      </div>
      {/* X-axis labels */}
      <div className="flex justify-around gap-2">
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="h-3 w-8 bg-gray-100 rounded"></div>
        ))}
      </div>
    </div>
  );
};

export default CardSkeleton;
